import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { history, store } from 'store';
import { graphql } from 'react-apollo';
import { QUERY_CROPS_SIZE_FOR_FIELD } from 'api/field';
import { change } from 'redux-form';
import cn from 'classnames';
import {
  formatCoordinate,
  splitFieldName,
  getHarvestedFlag,
} from 'common/utils';
import { base64url_encode, base64_decode } from 'util/base64';
import { DRAWING_ZOOM_LEVEL, ROUTE_FIELDS_DETAIL } from 'common/constants';
import { locationsimple as Location } from 'common/svg/icons';
import addFieldGif from 'common/gifs/add-field.gif';
import { FETCH_ALL_FIELDS } from 'api/field';
import { Query } from 'react-apollo';
import { compose } from 'redux';
import { banner } from 'actions';

import {
  BannerComponent,
  MapComponent,
  LevelNav,
  ErrorBoundary,
  Button,
} from 'common/components';
import { FieldForm } from 'containers';
import { Redirect } from 'react-router-dom';
import './index.css';

export class FieldEdit extends Component {
  state = {
    showFieldForm: this.props.match.params.encodedId ? true : false,
    shape: [],
    location: {},
    size: null,
    initForm: false,
    isDrawing: false,
    isDrawingCompleted: false,
  };

  _showFieldForm = () => {
    this.setState({ showFieldForm: true });
  };

  _setFieldGeo = (shape, size) => {
    this.setState({ shape, size });
  };

  _toggleDrawing = () => this.setState({ isDrawing: !this.state.isDrawing });

  _setFieldLocaiton = location => {
    this.setState({ location }, () => {
      const { lat, lng } = location;
      const coordsStr = `${formatCoordinate(lat)}, ${formatCoordinate(lng)}`;
      store.dispatch(change('fieldform', 'location', location));
      store.dispatch(change('fieldform', 'coordinates', coordsStr));
    });
  };

  _showSetupField = () => this.state.location && this.state.shape.length >= 3;

  _getFieldForm = fields => {
    const {
      browser,
      match: { params },
      goToDetailPage,
      goToNewFieldPage,
      goBack,
      triggerBanner,
    } = this.props;
    const id =
      params && params.encodedId ? base64_decode(params.encodedId) : null;
    const existingFieldNames = fields ? fields.map(field => field.name) : [];
    const currentField = fields && fields.find(field => field.id === id);
    if (currentField && !this.state.initForm) {
      const { shape, location, size } = currentField;
      this.setState({
        shape,
        location,
        size: size.size,
        initForm: true,
      });
    }

    // Left field form render
    return (
      <aside className="column is-one-third is-gapless field-wrapper__aside">
        <div
          className={cn('column__inner', {
            addfield__leftpanel: browser.greaterThan.mobile,
          })}
        >
          <FieldForm
            size={this.state.size}
            location={this.state.location}
            shape={this.state.shape}
            coordinates={`${formatCoordinate(
              this.state.location.lat
            )}, ${formatCoordinate(this.state.location.lng)}`}
            existingFieldNames={existingFieldNames}
            currentField={currentField}
            onCancel={goBack}
            formTitle={id ? 'Edit Field' : 'Setup Field'}
            used={this.props.used}
            goToDetailPage={goToDetailPage}
            goToNewFieldPage={goToNewFieldPage}
            triggerBanner={triggerBanner}
            id={id}
          />
        </div>
      </aside>
    );
  };

  _getLeftPanel = (enableDrawing, zoomInMore) => {
    return (
      <aside className="column is-one-third field-wrapper__aside">
        <div className="column__inner addfield__leftpanel">
          {this.state.isDrawing ? (
            <div className="addfield__container addfield__container--tight">
              <h3 className="text--header text--medium">Draw the Field</h3>
              <p className="text--bold text--medium addfield__content">
                Tap on the map to create a corner point and continue drawing.
                Finish by connecting the last point to the first corner. Use the
                Cancel button to undo the drawing.
              </p>
              <div className="text--center">
                <div>
                  <img src={addFieldGif} className="addfield__gif" />
                </div>
                <div className={'field__group'}>
                  <fieldset className={'field text--center'}>
                    {this.state.isDrawingCompleted ? (
                      <Button
                        className="btn btn--primary"
                        onClick={this._showFieldForm}
                      >
                        Done
                      </Button>
                    ) : (
                      <Button className="btn" onClick={this._toggleDrawing}>
                        Cancel
                      </Button>
                    )}
                  </fieldset>
                </div>
              </div>
            </div>
          ) : (
            <div className="addfield__container">
              <h3 className="text--header text--medium">Locate your Field</h3>
              <div className="text--bold text--medium addfield__content">
                Locate your field by scrolling & zooming through the map on the
                right. You can also click on the GPS icon{' '}
                <span>
                  <Location className="addfield__location" />
                </span>
                to zoom into your current location.
              </div>
              {zoomInMore && (
                <div className="text--center">
                  <Button className="btn btn--disabled">Zoom In More</Button>
                </div>
              )}
              {enableDrawing && (
                <div className="text--center">
                  <Button
                    className="btn btn--primary"
                    onClick={this._toggleDrawing}
                  >
                    Start Drawing
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>
      </aside>
    );
  };

  _getMobileUI = (enableDrawing, zoomInMore) => {
    const { isDrawing, isDrawingCompleted, showFieldForm } = this.state;
    let header = 'Zoom and locate your field';
    let button = {};

    if (zoomInMore) {
      button = {
        className: 'btn--disabled',
        text: 'ZOOM IN MORE',
      };
    }

    if (enableDrawing && !isDrawing) {
      button = {
        onClick: this._toggleDrawing,
        text: 'START DRAWING',
      };
    }

    if (enableDrawing && isDrawing && !showFieldForm) {
      header = 'Draw your field';
      button = {
        onClick: this._toggleDrawing,
        text: 'CANCEL',
      };
    }

    if (isDrawingCompleted && !showFieldForm) {
      header = 'Adjust the corner points';
      button = {
        onClick: this._showFieldForm,
        text: 'Done',
      };
    }

    if (showFieldForm) {
      header = 'Add Field';
    }

    const { className = '', ...buttonProps } = button;
    const buttonComponent = Object.entries(button).length > 0 && (
      <Button
        className={`btn addfield__button ${className}`}
        {...buttonProps}
      />
    );

    return {
      header,
      button: buttonComponent,
    };
  };

  // Main render
  render() {
    const {
      match: { params },
      zoom,
      browser,
    } = this.props;
    const { showFieldForm, shape, isDrawing, isDrawingCompleted } = this.state;
    const id =
      params && params.encodedId ? base64_decode(params.encodedId) : null;
    const mode = id ? 'edit' : 'add';
    const enableDrawing = zoom >= DRAWING_ZOOM_LEVEL;
    const zoomInMore = zoom < DRAWING_ZOOM_LEVEL;
    const { header, button } = this._getMobileUI(enableDrawing, zoomInMore);
    const desktop = browser.greaterThan.mobile;

    return (
      <ErrorBoundary>
        <Fragment>
          <BannerComponent theme={['fixed', 'strong', 'mobile-fixed']}>
            <LevelNav
              nav={{
                left: {
                  label: <span className={'visible--desktop'}>Back</span>,
                  action: () => history.goBack(),
                },
                center: {
                  label: !desktop && mode !== 'edit' ? header : `${mode} Field`,
                },
              }}
            />
          </BannerComponent>

          <Query
            query={FETCH_ALL_FIELDS}
            fetchPolicy="cache-and-network"
            variables={{ active: true }}
          >
            {({ loading, error, data }) => {
              if (loading || error) return null; // handle side effects here in the future.

              const { getAllFields, getAllCropsForField: crops } = data;
              // add crops to each fields
              const fields =
                getAllFields &&
                getAllFields.map(field => ({
                  ...field,
                  crops:
                    crops &&
                    crops.filter(crop => crop.fieldName === field.name),
                }));

              // for edit mode, filter out only one
              const selectedFields = id
                ? fields && fields.filter(field => field.id === id)
                : fields;
              // set up base polygons
              let polygons = (selectedFields || []).map(item => ({
                geojson: item.geojson ? JSON.parse(item.geojson) : null,
                paths: item.shape,
                title: item.name,
                harvested: getHarvestedFlag(item.crops) || false,
                size: item.size || [],
                crops: item.crops || [],
              }));

              // edit mode map polygons
              if (showFieldForm) {
                polygons = [...polygons];
                // if add mode map, add paths from state
                if (!id) {
                  polygons = polygons.concat([{ paths: shape }]);
                }
              }

              if (mode === 'edit' && polygons.length === 0)
                return <Redirect to="/error" />;

              return (
                <div
                  className={cn(
                    'field-wrapper__wrapper columns columns--white is-gapless',
                    !showFieldForm && 'field-wrapper--mapactive'
                  )}
                >
                  {showFieldForm ? (
                    <Fragment>
                      {this._getFieldForm(fields)}
                      <MapComponent
                        key="viewmode"
                        type="viewedit"
                        polygons={polygons}
                        marker={this.state.location}
                        markerDraggable
                        usePreservedLocation
                        onLocationUpdate={location =>
                          this._setFieldLocaiton(location)
                        }
                      />
                    </Fragment>
                  ) : (
                    <Fragment>
                      {desktop && this._getLeftPanel(enableDrawing, zoomInMore)}
                      <MapComponent
                        key="editmode"
                        type="editpoly"
                        polygons={polygons}
                        enableDrawing={
                          enableDrawing && isDrawing && !isDrawingCompleted
                        }
                        control={{
                          position: 'BOTTOM_CENTER',
                          component:
                            !desktop && mode !== 'edit' ? button : null,
                        }}
                        markerDraggable
                        disableZoom={isDrawing}
                        usePreservedLocation
                        hideZoomControl={isDrawing || !desktop}
                        onPolygonCompleted={() =>
                          this.setState({
                            isDrawingCompleted: true,
                            enableDrawing: false,
                          })
                        }
                        onLocationUpdate={location =>
                          this._setFieldLocaiton(location)
                        }
                        onPolygonUpdated={(location, shape, area) => {
                          this._setFieldLocaiton(location);
                          this._setFieldGeo(shape, area);
                        }}
                      />
                    </Fragment>
                  )}
                </div>
              );
            }}
          </Query>
        </Fragment>
      </ErrorBoundary>
    );
  }
}

FieldEdit.propTypes = {
  field: PropTypes.object,
  match: PropTypes.object,
  goToDetailPage: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  goToNewFieldPage: PropTypes.func.isRequired,
  used: PropTypes.number,
  zoom: PropTypes.number,
  browser: PropTypes.object.isRequired,
  triggerBanner: PropTypes.func.isRequired,
};

const mapState = ({ browser, field, map: { zoom } }) => ({
  browser,
  field,
  zoom,
});

const mapDispatch = {
  goToDetailPage: link => push(link),
  goBack: () => history.goBack(),
  goToNewFieldPage: ({ name }) =>
    push(`${ROUTE_FIELDS_DETAIL}/${base64url_encode(name)}`),
  triggerBanner: (id, message, isError) => banner.display(id, message, isError),
};

const enhance = compose(
  graphql(QUERY_CROPS_SIZE_FOR_FIELD, {
    options: ({
      match: {
        params: { encodedId },
      },
    }) => {
      if (encodedId) {
        const { fieldName } = splitFieldName(base64_decode(encodedId));
        return { variables: { fieldName } };
      }
      return { skip: true };
    },
    props: ({ data: { getAllCropsForField } }) => {
      const used = getAllCropsForField
        ? getAllCropsForField.reduce(
            (accumulator, currentValue) =>
              accumulator + currentValue.plantedArea.size,
            0
          )
        : 0;
      return { used };
    },
  }),
  connect(
    mapState,
    mapDispatch
  )
);

export default enhance(FieldEdit);



// WEBPACK FOOTER //
// ./src/pages/Field/Edit/index.js